import React, { useEffect, useState, useRef } from "react";
import _ from "lodash";

// third party
import { connect } from "react-redux";

// components
import Loading from "UIComponents/Loading";
import LessonPlanningAssistant from "ClassRoom/components/AddAssignment/LessonPlanningAssistant";

// modules
import { ResourceDetailsContext } from "UnitPlans/modules/UnitPlanModule";
import { updateAIDataInRedux } from "Assessments/modules/AssessmentModule";

// scss
import classes from "./AITutorV2.scss";

const testId = "assessment-aiTutor";

const styles = {
  footerInnerContainerStyle: {
    border: "1px solid var(--border-secondary)",
    borderRadius: "8px",
  },
  loadingContainerStyle: {
    position: "absolute",
    width: "100%",
    height: "100%",
    inset: 0,
    zIndex: 100000,
    backgroundColor: "var(--surface-primary-enabled)",
  },
};

const CHAT = "CHAT";
const TASK_DETAILS = "TASK_DETAILS";

const AITutorV2 = props => {
  const {
    portalType = "PLANNER",
    sourceFrom,
    resourceId,
    assessmentMode,
    mode,
    courseId,
    selectedCourseId,
    selectedCourse,
    unitPlanId,
    children,
    middlePaneRef,
    selectedTab,
    learningCourseId,
    updateAIDataInRedux,
    handleIsGeneratingAIResponse,
  } = props;

  const [isLoading, setIsLoading] = useState(!middlePaneRef);

  const isRefSet = useRef(false);

  useEffect(() => {
    updateAIDataInRedux({ aiTutorSelectedTab: CHAT });
  }, [updateAIDataInRedux]);

  // this will make sure that middlePaneRef is set before we show the component
  useEffect(() => {
    if (isRefSet.current) {
      setIsLoading(false);
      return;
    }

    if (!middlePaneRef) {
      setIsLoading(true);
      updateAIDataInRedux({
        aiTutorSelectedTab: TASK_DETAILS,
        showAITutorSelectedTab: false,
      });
    } else {
      setTimeout(() => {
        isRefSet.current = true;
        setIsLoading(false);
        updateAIDataInRedux({
          aiTutorSelectedTab: CHAT,
          showAITutorSelectedTab: true,
        });
      }, 1000);
    }
  }, [middlePaneRef, isLoading, updateAIDataInRedux]);

  const renderContainer = assessmentDetails => {
    const { isDraft, isFromUnitPlan, creationMode } = assessmentDetails || {};

    switch (selectedTab) {
      case CHAT:
        return (
          <LessonPlanningAssistant
            portalType={portalType}
            sourceFrom={sourceFrom}
            leId={resourceId}
            mode={assessmentMode || mode}
            courseId={courseId || selectedCourseId}
            selectedCourse={selectedCourse}
            unitPlanId={unitPlanId}
            isFromUnitPlan={isFromUnitPlan}
            creationMode={creationMode}
            isDraft={isDraft}
            isAITutor={true}
            middlePaneRef={middlePaneRef}
            testId={testId}
            learningCourseId={learningCourseId}
            footerInnerContainerStyle={styles.footerInnerContainerStyle}
            handleIsGeneratingAIResponse={handleIsGeneratingAIResponse}
          />
        );
      case TASK_DETAILS:
        return <div className={classes.overflowYAuto}>{children}</div>;
      default:
        return null;
    }
  };

  return (
    <ResourceDetailsContext.Consumer>
      {assessmentDetails => {
        return (
          <div className={classes.container}>
            {renderContainer(assessmentDetails)}

            {isLoading ? (
              <Loading containerStyle={styles.loadingContainerStyle} />
            ) : null}
          </div>
        );
      }}
    </ResourceDetailsContext.Consumer>
  );
};

const mapStateToProps = state => {
  const aiData = _.get(state, "assessment.aiData", {});
  const selectedTab = _.get(aiData, "aiTutorSelectedTab");

  return { selectedTab };
};

const mapActionCreators = {
  updateAIDataInRedux,
};

export default connect(mapStateToProps, mapActionCreators)(AITutorV2);
